import { render } from "./StudentPlatform.vue?vue&type=template&id=ef658ce2&scoped=true"
import script from "./StudentPlatform.vue?vue&type=script&lang=js"
export * from "./StudentPlatform.vue?vue&type=script&lang=js"

import "./StudentPlatform.vue?vue&type=style&index=0&id=ef658ce2&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef658ce2"]])

export default __exports__